import { IAction } from 'coral-utility';

export interface INavigationState {
  items: NavigationItems[];
}

export interface NavigationItems {
  id: string;
  label: string;
  uri: string;
  route: string;
  isVisible: boolean;
  sortOrder: number;
  __children: NavigationItems[];
}

const navigationActionTypes = {
  GET_NAVIGATION_ITEMS: 'GET_NAVIGATION_ITEMS',
  GET_NAVIGATION_ITEMS_SUCCESS: 'GET_NAVIGATION_ITEMS_SUCCESS',
  GET_NAVIGATION_ITEMS_FAILURE: 'GET_NAVIGATION_ITEMS_FAILURE',
};

export interface INavigationPayload {
  items: NavigationItems[];
}

export interface INavigationAction extends IAction {
  payload: INavigationPayload;
}

export type NavigationActions = IAction | INavigationAction;

export default navigationActionTypes;
